module.exports = __webpack_public_path__ + "media/images/parallax/illustration-do-foreground-039207c674f3d831ae232a371529820f.png";